<template>
    <Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
        <!-- Start Slider area -->
        <div class="slider-area slider-style-2 variation-2 height-450 bg_image"
             :style="{'background-image': `url(${require(`@/assets/images/banner-index.png`)})`}">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-xl-6">
            <div class="inner text-start" data-aos="fade-up" data-aos-delay="100">
													<h1 class="title">堅持「數雲融合」戰略定位</h1>
													<h1 class="title" style="font-size: 32px">深度融合雲原生、數字原生、AI原生</h1>
													<h1 class="title" style="font-size: 32px">構建覆蓋企業數字化轉型全周期的能力矩陣</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Separator/>

        <!-- Start Elements Area -->
        <div class="rwt-advance-tab-area rn-section-gap">
						<div class="container">
							<h2 class="w-600 title text-center">AI產品及服務</h2>
							<div style="margin-top: 72px">
								<div class="d-flex flex-column flex-lg-row flex-wrap gap-3">
									<div class="swiper-slide index-slide" v-for="(img,index) in bannerList" :key="index">
										<img :src="img.imgUrl" />
										<div class="con-box con-box2">
											<div class="title">{{img.title}}</div>
											<div class="text">{{img.text}}</div>
										</div>
									</div>
								</div>
							</div>
            </div>
        </div>
        <!-- End Elements Area -->

			<Separator/>

			<div class="rwt-advance-tab-area rn-section-gap">
				<div class="container">
							<h2 class="w-600 title text-center">數據產品及服務</h2>
					<div style="margin-top: 72px">
						<div class="d-flex flex-column flex-lg-row flex-wrap gap-3">
							<div class="swiper-slide index-slide" v-for="(img,index) in banner2List" :key="index">
								<img :src="img.imgUrl" />
								<div class="con-box">
									<div class="title">{{img.title}}</div>
									<div class="text">{{img.text}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<Separator/>

			<div class="rwt-advance-tab-area rn-section-gap">
				<div class="container">
							<h2 class="w-600 title text-center">雲服務</h2>
					<div style="margin-top: 72px">
						<div class="d-flex flex-column flex-lg-row flex-wrap gap-3">
							<div class="swiper-slide index-slide" v-for="(img,index) in banner3List" :key="index">
								<img :src="img.imgUrl" />
								<div class="con-box con-box2">
									<div class="title">{{img.title}}</div>
									<div class="text">{{img.text}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
    </Layout>
</template>

<script>
    import Layout from '../../components/common/Layout'
    import Separator from '../../components/elements/separator/Separator'
		import Swiper from 'swiper'

		import "swiper/css/swiper.css";

    export default {
        name: 'Index',
        components: {Separator, Layout},
        data() {
            return {
							bannerList: [
								{
									imgUrl: require(`@/assets/images/s1.png`),
									title: '企業級Agent中台',
									text: '為企業量身打造生成式AI（GenAI）落地引擎：一站式解決選、練、用、管全流程難題'
								},
								{
									imgUrl: require(`@/assets/images/s2.png`),
									title: 'DeepSeek企業版',
									text: '企業級AI解決方案，推動生成式AI在垂直領域的深度賦能'
								},
								{
									imgUrl: require(`@/assets/images/s3.png`),
									title: 'PC本地部署大模型',
									text: '強調數據本地化處理，避免敏感數據上傳雲端，從源頭保障隱私安全'
								},
								{
									imgUrl: require(`@/assets/images/s4.png`),
									title: '企業級一站式GenAI平台',
									text: '支持全流程閉環應用（數據→訓練→部署→場景落地），全棧私有化部署，支持本地數據中心、混合雲及信創雲環境'
								}
							],
							banner2List: [
								{
									imgUrl: require(`@/assets/images/s5.png`),
									title: '數據安全管控平台',
									text: '構建覆蓋數據全生命周期的安全防護體系，通過模塊化集成實現全域聯防'
								},
								{
									imgUrl: require(`@/assets/images/s6.png`),
									title: '數據治理諮詢與實施服務',
									text: '實現數據從採集到銷毀的全生命周期管理，確保業務決策的可靠性與高效率'
								}
							],
							banner3List: [
								{
									imgUrl: require(`@/assets/images/s7.png`),
									title: '一體化互聯網解決方案',
									text: '面向多領域提供複雜系統研發完整解決方案，提高研發效能，提升研發能力水平，實現各組織間協同研發'
								}
							],
            }
        },
			mounted() {
			}
    }
</script>
<style lang="scss" scoped>
.swiper-slide {
	text-align: center;
	font-size: 18px;
	background: #fff;
	display: flex;
	align-items: center;
	transition: 300ms;
	justify-content: center;
	position: relative;
	border-radius: 8px;
	img {
		border-radius: 8px;
		width: 100%;
	}

	.con-box {
		text-align: left;
		width: 100%;
		position: absolute;
		left: 0;
		bottom: 0;
		padding: 12px 16px;
		border-radius: 0 0 8px 8px;
		color: #fff;
		background: linear-gradient(to right, #D3001D, rgba(211, 0, 29, 0.1));
		min-height: 104px;
		&.con-box2 {
			background: linear-gradient(to right, #2350a0, rgba(35,80,160,0.1));
		}
		.title {
			font-size: 20px;
		}

		.text {
			font-size: 14px;
		}
	}
}
.home-programme-list {
	margin-top: 60px;
	.clearfix {
		display: block;
		list-style: none outside none;
		padding: 0;
		margin: 0;
	}
	li {
		float: left;
		width: 33.333%;
		.block-box {
			position: relative;
			.pic {
				position: relative;
				overflow: hidden;
				&:before {
					content: '';
					width: 100%;
					height: 100%;
					background-color: rgba(000, 000, 000, 0.5);
					position: absolute;
					top: 0;
					left: 0;
					z-index: 3;
					transition: all 0.5s ease;
					-webkit-transition: all 0.5s ease;
					-moz-transition: all 0.5s ease;
				}
				img {
					transition: all 0.5s ease;
				}
			}
			&:hover .pic {
				&:before {
					display: none;
				}
				img {
					transform: scale(1.1);
				}
			}
			.cont-inner {
				width: 100%;
				height: 100%;
				position: absolute;
				left: 0;
				bottom: 0;
				z-index: 5;
				.icon {
					width: 48px;
					margin: 64px auto 0;
					img {
						display: block;
						width: 100%;
					}
				}
				.cont-box {
					color: #fff;
					text-align: center;
					margin-top: 32px;
					.title {
						font-size: 24px;
						font-weight: bold;
					}
					.text {
						margin-top: 8px;
						font-size: 16px;
					}
				}
			}
		}
	}
}
@media only screen and (max-width: 768px) {
	.home-programme-list {
		margin-top: 0;
		li {
			width: 100%;
		}
	}
}
.js-m {
	transform: translate(0, 30px);
	transition: all 0.8s cubic-bezier(0.79, -0.27, 0.21, 0.82);
}
.product {
	margin-top: 72px;
	display: flex;
	gap: 20px;
	.pic {
		width: 50%;
		img {
			width: 100%;
		}
	}
	.txt {
		flex: 1;
		font-size: 22px;
		text-align: justify;
	}

}
.index-slide {
	flex: 0 0 calc(50% - 1rem);
}
@media only screen and (max-width: 768px) {
	.index-slide {
		width: 100%;
		flex: 1;
		overflow: hidden;
	}
}
</style>
